export const STORE_URLS = {
  ios: "https://apps.apple.com/id/app/myhero-hpam/id1499297292",
  android: "https://play.google.com/store/apps/details?id=com.hpam.myhero",
  fallback: "https://myhero.id/download",
};

/**
 * open.myhero.id / open-dev.myhero.id only exist as app deeplink (universal link) domains.
 * Landing there in a browser means the OS did not hand the link to the app, i.e. the app is
 * not installed — so every path on that host goes to the store instead of the 404 page.
 */
export const isDeeplinkHost = (hostname = "") =>
  /^open(-dev)?\.myhero\.id$/i.test(hostname);

/**
 * Play Store keeps this string and hands it to the app on first launch (Install Referrer API),
 * which is how the deeplink survives the install — no attribution SDK involved.
 * Read on the app side with InstallReferrerClient.getInstallReferrer().
 */
export const buildPlayReferrer = (path = "") =>
  new URLSearchParams({
    utm_source: "myhero_web",
    utm_medium: "deeplink",
    deeplink: path,
  }).toString();

export const getStoreUrl = (userAgent = "", maxTouchPoints = 0, path = "") => {
  if (/android/i.test(userAgent)) {
    // Root carries no destination, so there is nothing worth deferring.
    if (!path || path === "/") return STORE_URLS.android;

    return `${STORE_URLS.android}&referrer=${encodeURIComponent(
      buildPlayReferrer(path)
    )}`;
  }

  // iPadOS 13+ sends a Macintosh UA; touch points tell it apart from a real Mac.
  const isIpadOS = /macintosh/i.test(userAgent) && maxTouchPoints > 1;
  if (/iphone|ipad|ipod/i.test(userAgent) || isIpadOS) return STORE_URLS.ios;

  return STORE_URLS.fallback;
};

/** Returns true when it redirected, so the caller can skip rendering the app. */
export const redirectDeeplinkHostToStore = () => {
  const { hostname, pathname, search } = window.location;

  if (!isDeeplinkHost(hostname)) return false;

  window.location.replace(
    getStoreUrl(
      window.navigator.userAgent,
      window.navigator.maxTouchPoints,
      `${pathname}${search}`
    )
  );

  return true;
};
